import React from 'react';
import { motion } from 'framer-motion';
interface RevealProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
  as?: 'div' | 'li' | 'section';
}
export function Reveal({
  children,
  delay = 0,
  className = '',
  as = 'div'
}: RevealProps) {
  const MotionTag = motion[as];
  return <MotionTag className={className} initial={{
    opacity: 0,
    y: 18
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.25
  }} transition={{
    duration: 0.3,
    ease: [0.23, 1, 0.32, 1],
    delay
  }} data-id="element-276" data-mp="3ggz016kmsj4l">
      {children}
    </MotionTag>;
}